import record from "./record";

export default {
    graphql: {
        resourceBody: `
            ${record.graphql.resourceBody}
            resource_type
            is_bundle_content
            resource_wrapper_list_resource_id (limit: 0, order: "+id", offset: 0) {
                resource_wrapper_count
            }
        `,
        createVariables: (type) => `
            ${record.graphql.createVariables(type)}
        `,
        createQuery: (type) => `
            ${record.graphql.createQuery(type)}
        `,
        updateVariables: (type) => `
            ${record.graphql.updateVariables(type)}
            $is_bundle_content: Boolean
        `,
        updateQuery: (type) => `
            ${record.graphql.updateQuery(type)}
            is_bundle_content: $is_bundle_content
        `,
    },
};
